/* Cabinet Giant — Kitchen price comparison (sections/cg-kitchen-prices.liquid)
 * Prices: shop metafield cg_data.kitchen_prices (refreshed weekly).
 * Finishes: section blocks. Promotion: window.CGPromo (assets/promo.js).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-cgkp]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(document.getElementById(root.getAttribute('data-config')).textContent); } catch (e) { cfg = null; }
  var D = cfg && cfg.data;
  if (!D || !D.prices || !D.skus) { var err = root.querySelector('[data-cgkp-error]'); if (err) err.hidden = false; return; }

  // ---------- data ----------
  var SKUS = D.skus, UNI = D.universal || {};
  var LINES = (cfg.finishes || []).filter(function (f) { return f.code && D.prices[f.code]; }).map(function (f) {
    return { c: f.code, n: f.name, f: f.family || 'white', hex: f.swatch || '#dddddd', door: f.door || '', url: f.url || '#', p: D.prices[f.code] };
  });
  if (!LINES.length) return;

  var FAM = { white: 'Whites & creams', grey: 'Greys', blue: 'Blues', wood: 'Woods & browns', black: 'Black' };
  var FAMDOT = { white: '#efe9dc', grey: '#9a9e9b', blue: '#34495f', wood: '#9a6d45', black: '#1c1c1c' };
  var TIERS = {
    essentials: { label: 'Essentials', sub: 'Cabinets + basics', h: 30, corner: 'BBLC42/45-39', drawers: false, crown: false, rail: false, overRange: 'W3015B', overFridge: 'W3615B', pantry: false, endPanels: 0, extras: [] },
    popular: { label: 'Most popular', sub: 'Drawers, crown, lazy susan', h: 36, corner: 'LS3612', drawers: true, crown: true, rail: true, overRange: 'W3018B', overFridge: 'W3615B', pantry: false, endPanels: 1, extras: [['TCR-P21', 1]] },
    designer: { label: 'Designer', sub: '42″ uppers, pantry, pull-outs', h: 42, corner: 'LS3612', drawers: true, crown: true, rail: true, overRange: 'W3018B', overFridge: 'W361524B', pantry: true, endPanels: 2, extras: [['TCR-P21', 1], ['15RT-DR', 2]], spice: true, fridgePanel: true }
  };
  var SIZES = {
    '10x10': { label: '10×10 L-shape', btn: '10×10', sub: 'The benchmark', w: 120, h: 120, dx: '10′', dy: '10′', runBase: 240, runUpper: 240, bf: 2, wf: 2,
      slots: ['cb', 'drw18', 'sink', 'b15', 'cw', 'up30', 'up36', 'up24', 'up27', 'range', 'fridge'] },
    '12x12': { label: '12×12 L-shape', btn: '12×12', sub: 'More storage', w: 144, h: 144, dx: '12′', dy: '12′', runBase: 288, runUpper: 288, bf: 2, wf: 2,
      slots: ['cb', 'drw18', 'sink', 'b24', 'b15', 'cw', 'up30', 'up36', 'up24', 'up24', 'up27', 'range', 'fridge', 'swap'] },
    'u': { label: '10×12×10 U-shape', btn: 'U-shape', sub: 'Three walls', w: 144, h: 120, dx: '12′', dy: '10′', u: true, runBase: 384, runUpper: 384, bf: 3, wf: 3,
      slots: ['cb', 'cb', 'b15', 'drw24', 'b15', 'b12', 'sink', 'drw18', 'cw', 'cw', 'up27', 'range', 'up24', 'up15', 'up24', 'up36', 'up36', 'up30', 'fridge', 'swap'] },
    'island': { label: '12×14 L + island', btn: 'L + island', sub: '6′ island', w: 144, h: 168, dx: '12′', dy: '14′', runBase: 384, runUpper: 312, bf: 3, wf: 2, islandEnds: 2,
      slots: ['cb', 'drw18', 'sink', 'b24', 'b15', 'cw', 'up30', 'up36', 'up24', 'up24', 'up27', 'range', 'fridge', 'swap', 'swap', 'drw30', 'b30', 'b12', 'islandback', 'islandback'] }
  };
  var PLAN = {
    '10x10': { cA: [0, 0, 36, 24], cB: [0, 24, 24, 12], drw18: [36, 0, 18, 24], sink: [54, 0, 36, 24], dw: [90, 0, 24, 24], fTop: [114, 0, 6, 24], b15: [0, 36, 24, 15], range: [0, 51, 24, 30], fridge: [0, 81, 30, 36], fLeft: [0, 117, 24, 3] },
    '12x12': { cA: [0, 0, 36, 24], cB: [0, 24, 24, 12], drw18: [36, 0, 18, 24], sink: [54, 0, 36, 24], dw: [90, 0, 24, 24], b24: [114, 0, 24, 24], fTop: [138, 0, 6, 24], b15: [0, 36, 24, 15], range: [0, 51, 24, 30], fridge: [0, 81, 30, 36], swap1: [0, 117, 24, 24], fLeft: [0, 141, 24, 3] },
    'u': { cA: [0, 0, 36, 24], cB: [0, 24, 24, 12], b12t: [36, 0, 12, 24], sink: [48, 0, 36, 24], dw: [84, 0, 24, 24], cC: [108, 0, 36, 24], cD: [120, 24, 24, 12], b15: [0, 36, 24, 15], range: [0, 51, 24, 30], drw24: [0, 81, 24, 24], b15b: [0, 105, 24, 15], drw18: [120, 36, 24, 18], fridge: [114, 54, 30, 36], swap1: [120, 90, 24, 24], fRight: [120, 114, 24, 6] },
    'island': { cA: [0, 0, 36, 24], cB: [0, 24, 24, 12], drw18: [36, 0, 18, 24], sink: [54, 0, 36, 24], dw: [90, 0, 24, 24], b24: [114, 0, 24, 24], fTop: [138, 0, 6, 24], b15: [0, 36, 24, 15], range: [0, 51, 24, 30], fridge: [0, 81, 30, 36], swap1: [0, 117, 24, 24], swap2: [0, 141, 24, 24], fLeft: [0, 165, 24, 3], counter: [44, 80, 80, 40], iDrw: [48, 84, 30, 24], iB30: [78, 84, 30, 24], iB12: [108, 84, 12, 24] }
  };
  var IDS = ['counter', 'cA', 'cB', 'cC', 'cD', 'drw18', 'b12t', 'sink', 'dw', 'b24', 'fTop', 'b15', 'range', 'drw24', 'b15b', 'fridge', 'swap1', 'swap2', 'fLeft', 'fRight', 'iDrw', 'iB30', 'iB12'];
  var KIND = { cA: 'corner', cB: 'corner', cC: 'corner', cD: 'corner', drw18: 'drw', drw24: 'drw', iDrw: 'drw', sink: 'base', b12t: 'base', b24: 'base', b15: 'base', b15b: 'base', iB30: 'base', iB12: 'base', dw: 'appl', range: 'appl', fridge: 'appl', fTop: 'fill', fLeft: 'fill', fRight: 'fill', swap1: 'swap', swap2: 'swap', counter: 'counter' };
  var NAMES = { 'LS3612': 'Lazy susan corner base', 'BBLC42/45-39': 'Blind corner base', 'SB36B': 'Sink base 36″', 'BF3': 'Base filler 3″', 'TK8': 'Toe kick, 8′', 'CM96': 'Crown molding, 8′', 'LRM8': 'Light rail molding, 8′', 'EPB24D': 'Decorative end panel', 'BFP09': 'Spice pull-out 9″', 'REP2496': 'Refrigerator end panel', 'FBP4836': 'Island back panel', 'WP2484B': 'Pantry 24″ × 84″', 'W3015B': 'Over-range wall 30″ × 15″', 'W3018B': 'Over-range wall 30″ × 18″', 'W3615B': 'Over-fridge wall 36″ × 15″', 'W361524B': 'Over-fridge wall, 24″ deep', 'TCR-P21': 'Pull-out trash can', '15RT-DR': 'Roll-out tray' };
  // Wall-cabinet layer (12" deep strips along the walls). Fridge cabinet width is set at paint time (12" or 24" deep).
  var WPLAN = {
    '10x10': { wcA: [0, 0, 24, 24], wt30: [24, 0, 30, 12], wt36: [54, 0, 36, 12], wt24a: [90, 0, 24, 12], wfT: [114, 0, 6, 12], wl27: [0, 24, 12, 27], wlR: [0, 51, 12, 30], wlF: [0, 81, 12, 36], wfL: [0, 117, 12, 3] },
    '12x12': { wcA: [0, 0, 24, 24], wt30: [24, 0, 30, 12], wt36: [54, 0, 36, 12], wt24a: [90, 0, 24, 12], wt24b: [114, 0, 24, 12], wfT: [138, 0, 6, 12], wl27: [0, 24, 12, 27], wlR: [0, 51, 12, 30], wlF: [0, 81, 12, 36], wlS1: [0, 117, 12, 24], wfL: [0, 141, 12, 3] },
    'u': { wcA: [0, 0, 24, 24], wt24a: [24, 0, 24, 12], wt36: [48, 0, 36, 12], wt36b: [84, 0, 36, 12], wcB: [120, 0, 24, 24], wl27: [0, 24, 12, 27], wlR: [0, 51, 12, 30], wl24: [0, 81, 12, 24], wl15: [0, 105, 12, 15], wr30: [132, 24, 12, 30], wrF: [132, 54, 12, 36], wrS: [132, 90, 12, 24], wfR: [132, 114, 12, 6] },
    'island': { wcA: [0, 0, 24, 24], wt30: [24, 0, 30, 12], wt36: [54, 0, 36, 12], wt24a: [90, 0, 24, 12], wt24b: [114, 0, 24, 12], wfT: [138, 0, 6, 12], wl27: [0, 24, 12, 27], wlR: [0, 51, 12, 30], wlF: [0, 81, 12, 36], wlS1: [0, 117, 12, 24], wlS2: [0, 141, 12, 24], wfL: [0, 165, 12, 3] }
  };
  var WIDS = ['wcA', 'wcB', 'wt24a', 'wt30', 'wt36', 'wt36b', 'wt24b', 'wfT', 'wl27', 'wlR', 'wl24', 'wl15', 'wlF', 'wlS1', 'wlS2', 'wfL', 'wr30', 'wrF', 'wrS', 'wfR'];
  var WKIND = { wcA: 'wdc', wcB: 'wdc', wt24a: 'up24', wt24b: 'up24', wt30: 'up30', wt36: 'up36', wt36b: 'up36', wl27: 'up27', wl24: 'up24', wl15: 'up15', wr30: 'up30', wlR: 'range', wlF: 'fridge', wrF: 'fridge', wlS1: 'swap', wlS2: 'swap', wrS: 'swap', wfT: 'fill', wfL: 'fill', wfR: 'fill' };
  function baseSkuFor(id, T) {
    switch (id) {
      case 'cA': case 'cB': case 'cC': case 'cD': return T.corner;
      case 'drw18': return T.drawers ? 'DB18(3)' : 'B18';
      case 'drw24': return T.drawers ? 'DB24(3)' : 'B24B';
      case 'iDrw': return T.drawers ? 'DB30(3)' : 'B30B';
      case 'sink': return 'SB36B';
      case 'b12t': case 'iB12': return 'B12';
      case 'b24': return 'B24B';
      case 'b15': case 'b15b': return 'B15';
      case 'iB30': return 'B30B';
      case 'swap1': case 'swap2': return T.pantry ? 'WP2484B' : 'B24B';
      case 'fTop': case 'fLeft': case 'fRight': return 'BF3';
    }
    return '';
  }
  function wallSkuFor(id, T) {
    var k = WKIND[id], m;
    if (k === 'wdc') return 'WDC24' + T.h;
    if (k === 'range') return T.overRange;
    if (k === 'fridge') return T.overFridge;
    if (k === 'swap') return upperSku(24, T.h);
    if (k === 'fill') return 'WF3' + T.h;
    if ((m = k.match(/^up(\d+)$/))) return upperSku(+m[1], T.h);
    return '';
  }
  function shortSku(s) { if (s === 'BBLC42/45-39') return 'BBLC42'; return s.replace('(3)', '').replace(/(\d)B$/, '$1'); }
  var GROUPS = [['base', 'Base cabinets'], ['wall', 'Wall cabinets'], ['tall', 'Tall cabinets'], ['trim', 'Fillers, panels & molding'], ['accessory', 'Storage accessories']];
  var S = 2; // px per inch in the plan

  function upperSku(w, h) { return 'W' + String(w).padStart(2, '0') + h + (w >= 24 ? 'B' : ''); }
  function baseSku(w) { return 'B' + String(w).padStart(2, '0') + (w >= 24 ? 'B' : ''); }
  function buildList(sizeKey, tierKey) {
    var Z = SIZES[sizeKey], T = TIERS[tierKey], out = {}, order = [];
    function add(sku, qty, group) { if (!qty) return; if (!out[sku]) { out[sku] = { sku: sku, qty: 0, group: group }; order.push(sku); } out[sku].qty += qty; }
    Z.slots.forEach(function (s) {
      var m;
      if (s === 'cb') add(T.corner, 1, 'base');
      else if (s === 'cw') add('WDC24' + T.h, 1, 'wall');
      else if (s === 'sink') add('SB36B', 1, 'base');
      else if (s === 'range') add(T.overRange, 1, 'wall');
      else if (s === 'fridge') add(T.overFridge, 1, 'wall');
      else if (s === 'islandback') add('FBP4836', 1, 'trim');
      else if (s === 'swap') { if (T.pantry) add('WP2484B', 1, 'tall'); else { add('B24B', 1, 'base'); add(upperSku(24, T.h), 1, 'wall'); } }
      else if ((m = s.match(/^up(\d+)$/))) add(upperSku(+m[1], T.h), 1, 'wall');
      else if ((m = s.match(/^b(\d+)$/))) add(baseSku(+m[1]), 1, 'base');
      else if ((m = s.match(/^drw(\d+)$/))) add(T.drawers ? 'DB' + m[1] + '(3)' : baseSku(+m[1]), 1, 'base');
    });
    if (T.spice) add('BFP09', 1, 'base');
    add('BF3', Z.bf, 'trim'); add('WF3' + T.h, Z.wf, 'trim'); add('TK8', Math.ceil(Z.runBase / 96), 'trim');
    if (T.crown) add('CM96', Math.ceil(Z.runUpper / 96) + 1, 'trim');
    if (T.rail) add('LRM8', Math.ceil(Z.runUpper / 96), 'trim');
    add('EPB24D', T.endPanels + (Z.islandEnds || 0), 'trim');
    if (T.fridgePanel) add('REP2496', 1, 'trim');
    T.extras.forEach(function (e) { add(e[0], e[1], 'accessory'); });
    return order.map(function (k) { return out[k]; });
  }
  function unitPrice(line, sku) { if (UNI[sku] != null) return UNI[sku]; var i = SKUS.indexOf(sku); return i < 0 ? 0 : (line.p[i] || 0); }
  function total(line, list) { var t = 0; list.forEach(function (it) { t += unitPrice(line, it.sku) * it.qty; }); return Math.round(t); }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function itemName(sku) {
    if (NAMES[sku]) return NAMES[sku];
    var r;
    if ((r = sku.match(/^WDC24(\d\d)$/))) return 'Corner wall 24″ × ' + r[1] + '″';
    if ((r = sku.match(/^WF3(\d\d)$/))) return 'Wall filler 3″ × ' + r[1] + '″';
    if ((r = sku.match(/^W(\d\d)(\d\d)B?$/))) return 'Wall ' + (+r[1]) + '″ × ' + r[2] + '″';
    if ((r = sku.match(/^DB(\d\d)\(3\)$/))) return '3-drawer base ' + r[1] + '″';
    if ((r = sku.match(/^B(\d\d)B?$/))) return 'Base ' + (+r[1]) + '″';
    return sku;
  }
  function lum(hex) { var n = parseInt(String(hex).replace('#', ''), 16) || 0; return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function niceStep(span) { var c = [250, 500, 1000, 2000, 2500, 5000]; for (var i = 0; i < c.length; i++) if (span / c[i] <= 5) return c[i]; return 10000; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function $(sel) { return root.querySelector(sel); }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- who is viewing ----------
  var b2b = cfg.b2b || {};
  var refLine = LINES.filter(function (l) { return l.c === b2b.refCode; })[0];
  var refRetail = refLine ? unitPrice(refLine, b2b.refSku) : 0;
  var wPct = 0;
  if (b2b.isB2B && refRetail > 0 && b2b.refPrice > 0) {
    wPct = Math.round((1 - (b2b.refPrice / 100) / refRetail) * 100);
    if (wPct < 1 || wPct >= 100) wPct = 0; // $0 accounts (Creative) and retail-priced B2B see retail
  }
  var isW = wPct > 0;

  function promo() { return window.CGPromo && !isW && window.CGPromo.isActive() ? window.CGPromo : null; }

  // ---------- state ----------
  var q = new URLSearchParams(location.search);
  var st = {
    size: SIZES[q.get('size')] ? q.get('size') : (cfg.startSize || '10x10'),
    tier: TIERS[q.get('tier')] ? q.get('tier') : (cfg.startTier || 'popular'),
    fam: 'all', sort: 'price', zoom: false, prices: 'regular', planView: 'base', code: '', codePct: 0, showRetail: false,
    sel: (q.get('finish') || '').toUpperCase()
  };
  if (!LINES.some(function (l) { return l.c === st.sel; })) st.sel = LINES[0].c;
  var shownMap = {}, fromMap = {}, tweenP = 1, raf = 0, tierFlip = 0, ready = false;

  // ---------- one-time DOM ----------
  var rowsEl = $('[data-rows]'), ticksEl = $('[data-ticks]'), roomEl = $('[data-room]');
  var rowEls = {};
  LINES.forEach(function (l) {
    var row = document.createElement('div');
    row.className = 'cgkp-row';
    row.innerHTML =
      '<button type="button" class="cgkp-rowbtn">' +
        '<span class="cgkp-who"><span class="cgkp-door" style="background-color:' + esc(l.hex) + '">' + (l.door ? '<img src="' + esc(img(l.door, 80)) + '" alt="" loading="lazy" width="26" height="38">' : '') + '</span>' +
        '<span class="cgkp-nm"><span class="cgkp-nt">' + esc(l.n) + '</span><span class="cgkp-nf">' + esc(FAM[l.f] || '') + '</span></span></span>' +
        '<span class="cgkp-track"><span class="cgkp-lane"><span class="cgkp-ghost"></span><span class="cgkp-bar"></span>' +
        '<span class="cgkp-val"><span class="cgkp-vp"></span><s class="cgkp-vw"></s><span class="cgkp-pill"></span></span></span></span>' +
        '<span class="cgkp-delta"></span>' +
      '</button>';
    row.querySelector('button').addEventListener('click', function () { st.sel = l.c; selFlip(); update(false); });
    rowsEl.appendChild(row);
    rowEls[l.c] = { row: row, btn: row.querySelector('button'), ghost: row.querySelector('.cgkp-ghost'), bar: row.querySelector('.cgkp-bar'), val: row.querySelector('.cgkp-val'), vp: row.querySelector('.cgkp-vp'), vw: row.querySelector('.cgkp-vw'), pill: row.querySelector('.cgkp-pill'), delta: row.querySelector('.cgkp-delta') };
  });
  var tickEls = [];
  for (var i = 0; i < 7; i++) { var t = document.createElement('div'); t.className = 'cgkp-tick'; t.innerHTML = '<span></span>'; ticksEl.appendChild(t); tickEls.push(t); }
  var markEls = [];
  for (var j = 0; j < 3; j++) { var mk = document.createElement('div'); mk.className = 'cgkp-mark'; mk.innerHTML = '<span></span>'; mk.style.opacity = 0; ticksEl.appendChild(mk); markEls.push(mk); }
  var pieceEls = {}, wallEls = {}, wlayer = $('[data-wlayer]'), pinSku = '', hlNow = '';
  function isCab(kind) { return kind === 'corner' || kind === 'drw' || kind === 'base' || kind === 'swap'; }
  function hl(sku) {
    hlNow = sku || '';
    Array.prototype.forEach.call(root.querySelectorAll('.cgkp-pc[data-sku], .cgkp-wc[data-sku], .cgkp-it[data-sku]'), function (e) {
      e.classList.toggle('is-hl', !!hlNow && e.getAttribute('data-sku') === hlNow);
    });
    renderInfo();
  }
  // Info strip under the plan: names the highlighted cabinet, with a button that jumps to it in the list.
  function renderInfo() {
    var box = $('[data-pinfo]'), hint = $('[data-planhint]');
    if (!box || !last) return;
    var it = hlNow ? last.list.filter(function (x) { return x.sku === hlNow; })[0] : null;
    if (!it) { box.hidden = true; if (hint) hint.hidden = false; return; }
    var sel = LINES.filter(function (l) { return l.c === st.sel; })[0] || LINES[0], each = unitPrice(sel, it.sku);
    $('[data-pinfo-text]').innerHTML = '<b>' + esc(itemName(it.sku)) + '</b> <span>' + esc(it.sku) + ' · ' + it.qty + '× ' + money(each) + (it.qty > 1 ? ' = ' + money(each * it.qty) : '') + '</span>';
    box.hidden = false; if (hint) hint.hidden = true;
  }
  function goToItem() {
    var sku = hlNow, box = $('[data-items]'), its = box.querySelectorAll('.cgkp-it'), row = null;
    for (var k = 0; k < its.length; k++) if (its[k].getAttribute('data-sku') === sku) { row = its[k]; break; }
    if (!row) return;
    pinSku = sku; scrollToItem(sku);
    row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    row.classList.remove('is-flash'); void row.offsetWidth; row.classList.add('is-flash');
  }
  function scrollToItem(sku) {
    var box = $('[data-items]'), its = box.querySelectorAll('.cgkp-it'), it = null;
    for (var k = 0; k < its.length; k++) if (its[k].getAttribute('data-sku') === sku) { it = its[k]; break; }
    if (it) box.scrollTop = Math.max(0, it.offsetTop - 40);
  }
  function bindHL(el) {
    el.addEventListener('mouseenter', function () { hl(el.getAttribute('data-sku')); });
    el.addEventListener('mouseleave', function () { hl(pinSku); });
    el.addEventListener('focus', function () { hl(el.getAttribute('data-sku')); });
    el.addEventListener('blur', function () { hl(pinSku); });
    el.addEventListener('click', function () { var s2 = el.getAttribute('data-sku'); pinSku = pinSku === s2 ? '' : s2; hl(pinSku); if (pinSku) scrollToItem(pinSku); });
  }
  IDS.forEach(function (id, idx) {
    var kind = KIND[id], btn = isCab(kind) || kind === 'fill';
    var p = document.createElement(btn ? 'button' : 'div');
    if (btn) { p.type = 'button'; bindHL(p); }
    p.className = 'cgkp-pc ' + kind;
    p.style.animationDelay = (120 + idx * 45) + 'ms';
    p.innerHTML = '<span class="cgkp-pl"></span>';
    roomEl.insertBefore(p, wlayer); pieceEls[id] = p;
  });
  WIDS.forEach(function (id, idx) {
    var p = document.createElement('button');
    p.type = 'button'; bindHL(p);
    p.className = 'cgkp-wc ' + (WKIND[id] === 'fill' ? 'fill' : 'cab');
    p.style.transitionDelay = (idx * 25) + 'ms';
    p.innerHTML = '<span class="cgkp-pl"></span>';
    wlayer.appendChild(p); wallEls[id] = p;
  });

  // controls
  function segButtons(container, opts, onPick) {
    container.innerHTML = '';
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = esc(o.label) + (o.sub ? '<small>' + esc(o.sub) + '</small>' : '');
      b.addEventListener('click', function () { onPick(o.key); });
      b.setAttribute('data-key', o.key);
      container.appendChild(b);
    });
  }
  segButtons($('[data-sizes]'), Object.keys(SIZES).map(function (k) { return { key: k, label: SIZES[k].btn, sub: SIZES[k].sub }; }), function (k) { st.size = k; update(true); });
  segButtons($('[data-tiers]'), Object.keys(TIERS).map(function (k) { return { key: k, label: TIERS[k].label, sub: TIERS[k].sub }; }), function (k) { st.tier = k; tierFlip++; update(true); });
  var famBox = $('[data-fams]');
  [{ k: 'all', label: 'All' }].concat(Object.keys(FAM).filter(function (f) { return LINES.some(function (l) { return l.f === f; }); }).map(function (f) { return { k: f, label: FAM[f], dot: FAMDOT[f] }; })).forEach(function (o) {
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('data-key', o.k);
    b.innerHTML = (o.dot ? '<i style="background-color:' + o.dot + '"></i>' : '') + esc(o.label);
    b.addEventListener('click', function () {
      st.fam = o.k;
      var vis = LINES.filter(function (l) { return o.k === 'all' || l.f === o.k; });
      if (!vis.some(function (l) { return l.c === st.sel; })) st.sel = vis[0].c;
      update(false);
    });
    famBox.appendChild(b);
  });
  $('[data-zoom]').addEventListener('click', function () { st.zoom = !st.zoom; update(false); });
  $('[data-sort]').addEventListener('click', function () { st.sort = st.sort === 'price' ? 'color' : 'price'; update(false); });
  var planToggle = $('[data-planview]');
  Array.prototype.forEach.call(planToggle.querySelectorAll('button'), function (b) {
    b.addEventListener('click', function () { st.planView = b.getAttribute('data-key'); update(false); });
  });
  var pinfoGo = $('[data-pinfo-go]');
  if (pinfoGo) pinfoGo.addEventListener('click', goToItem);
  var retailBtn = $('[data-retail]');
  retailBtn.addEventListener('click', function () { st.showRetail = !st.showRetail; update(true); });

  // comparison code (display only — NOT a checkout discount)
  var codeGrp = $('[data-codegrp]'), codeForm = $('[data-codeform]'), codeInput = $('[data-codeinput]'), codeChip = $('[data-codechip]'), codeErr = $('[data-codeerr]');
  if (isW && codeGrp) codeGrp.hidden = true;
  codeForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var raw = String(codeInput.value || '').toUpperCase().replace(/[\s-]/g, '');
    var m = raw.match(/^CA(\d{1,2})$/), n = m ? +m[1] : 0;
    if (n >= 1 && n <= 50) { st.code = 'CA' + n; st.codePct = n; codeErr.hidden = true; update(true); }
    else { codeErr.textContent = 'Code not recognized'; codeErr.hidden = false; }
  });
  codeInput.addEventListener('input', function () { codeErr.hidden = true; });
  $('[data-codeclear]').addEventListener('click', function () { st.code = ''; st.codePct = 0; codeInput.value = ''; update(true); });

  var heroDoor = $('[data-hero-door]'), selFlipN = 0;
  function selFlip() { selFlipN++; heroDoor.classList.remove('cgkp-swingA', 'cgkp-swingB'); void heroDoor.offsetWidth; heroDoor.classList.add(selFlipN % 2 ? 'cgkp-swingA' : 'cgkp-swingB'); }

  // ---------- compute + paint ----------
  var last = null;
  function compute() {
    var Z = SIZES[st.size], T = TIERS[st.tier], P = promo();
    var list = buildList(st.size, st.tier), baseList = buildList(st.size, 'essentials');
    var baseSkus = {}; baseList.forEach(function (it) { baseSkus[it.sku] = 1; });
    var codePct = isW ? 0 : st.codePct;
    var sale = !!P && st.prices === 'sale' && !codePct;
    var flatPct = codePct ? codePct : (isW && !st.showRetail ? wPct : 0);
    var reg = {}, disc = {}, totals = {};
    LINES.forEach(function (l) {
      var r = total(l, list); reg[l.c] = r;
      disc[l.c] = sale ? P.pctFor(r) : flatPct;
      totals[l.c] = Math.round(r * (1 - disc[l.c] / 100));
    });
    return { Z: Z, T: T, P: P, list: list, baseSkus: baseSkus, codePct: codePct, sale: sale, reg: reg, disc: disc, totals: totals };
  }

  function update(retween) {
    var c = compute();
    if (retween || !last) startTween(c);
    last = c;
    paint(c);
  }

  function startTween(c) {
    LINES.forEach(function (l) { fromMap[l.c] = shownMap[l.c] == null ? (reduce ? c.totals[l.c] : 0) : shownMap[l.c]; });
    cancelAnimationFrame(raf);
    if (reduce) { tweenP = 1; return; }
    tweenP = 0;
    var t0 = performance.now();
    (function step() {
      tweenP = Math.min(1, (performance.now() - t0) / 950);
      paintNumbers(last);
      if (tweenP < 1) raf = requestAnimationFrame(step);
    })();
  }

  function paintNumbers(c) {
    if (!c) return;
    var k = ease(tweenP);
    LINES.forEach(function (l) {
      var f = fromMap[l.c] == null ? c.totals[l.c] : fromMap[l.c];
      shownMap[l.c] = f + (c.totals[l.c] - f) * k;
      rowEls[l.c].vp.textContent = money(shownMap[l.c]);
    });
    $('[data-hero-total]').textContent = money(shownMap[st.sel]);
  }

  function setPressed(container, key) {
    Array.prototype.forEach.call(container.querySelectorAll('button'), function (b) {
      var on = b.getAttribute('data-key') === key;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function paint(c) {
    var Z = c.Z, T = c.T, P = c.P;
    setPressed($('[data-sizes]'), st.size); setPressed($('[data-tiers]'), st.tier); setPressed(famBox, st.fam);
    var famOrder = ['white', 'grey', 'blue', 'wood', 'black'];
    var vis = LINES.filter(function (l) { return st.fam === 'all' || l.f === st.fam; });
    var sorted = vis.slice().sort(function (a, b) {
      return st.sort === 'price' ? (c.totals[a.c] - c.totals[b.c]) || a.n.localeCompare(b.n) : (famOrder.indexOf(a.f) - famOrder.indexOf(b.f)) || (c.totals[a.c] - c.totals[b.c]);
    });
    var vals = vis.map(function (l) { return c.totals[l.c]; });
    var lo = Math.min.apply(null, vals), hi = Math.max.apply(null, vals);
    var rv = LINES.map(function (l) { return c.reg[l.c]; }), rLo = Math.min.apply(null, rv), rHi = Math.max.apply(null, rv);
    var allLo = Math.min.apply(null, LINES.map(function (l) { return c.totals[l.c]; }));
    var aMin = 0, aMax = Math.ceil(rHi * 1.04 / 1000) * 1000;
    if (st.zoom) { var s0 = niceStep((rHi - allLo) * 1.4); aMin = Math.floor(allLo * 0.97 / s0) * s0; aMax = Math.ceil(rHi * 1.015 / s0) * s0; }
    function pctOf(v) { return Math.max(0, Math.min(100, (v - aMin) / (aMax - aMin) * 100)); }
    var step = st.zoom ? niceStep(aMax - aMin) : niceStep(aMax);
    tickEls.forEach(function (el, i) {
      var v = aMin + i * step, on = v <= aMax;
      el.style.left = (on ? pctOf(v) : 100) + '%'; el.style.opacity = on ? 1 : 0;
      el.firstChild.textContent = on ? (v >= 1000 ? '$' + (v / 1000) + 'k' : '$' + v) : '';
    });
    var tiers = c.sale && P ? P.tiers : [];
    markEls.forEach(function (el, i) {
      var tr = tiers[i], inR = tr && tr.min > aMin && tr.min < aMax;
      el.style.left = (inR ? pctOf(tr.min) : 0) + '%'; el.style.opacity = inR && ready ? 1 : 0;
      el.firstChild.textContent = tr ? tr.pct + '% off over ' + money(tr.min) : '';
    });

    // rows
    var rank = {}; sorted.forEach(function (l, i) { rank[l.c] = i; });
    var hidden = vis.length;
    var showWas = c.sale || c.codePct > 0;
    var sel = LINES.filter(function (l) { return l.c === st.sel; })[0] || LINES[0];
    LINES.forEach(function (l) {
      var e = rowEls[l.c], on = rank[l.c] != null, r = on ? rank[l.c] : hidden++;
      var tt = c.totals[l.c], d = tt - lo;
      e.row.style.transform = 'translateY(calc(var(--cgkp-rh) * ' + r + '))';
      e.row.style.opacity = on ? 1 : 0; e.row.style.visibility = on ? 'visible' : 'hidden';
      e.row.classList.toggle('is-sel', l.c === sel.c);
      e.row.classList.toggle('is-low', on && tt === lo && l.c !== sel.c);
      e.btn.setAttribute('aria-pressed', l.c === sel.c ? 'true' : 'false');
      e.btn.setAttribute('aria-label', l.n + ', ' + money(tt) + (d === 0 ? ', lowest price' : ', ' + money(d) + ' more than the lowest'));
      e.btn.tabIndex = on ? 0 : -1;
      var delay = ready ? r * 28 : 0;
      [e.ghost, e.bar, e.val].forEach(function (x) { x.style.transitionDelay = delay + 'ms'; });
      e.bar.style.width = (ready ? pctOf(tt) : 0) + '%';
      e.ghost.style.width = (ready ? pctOf(c.reg[l.c]) : 0) + '%';
      e.val.style.left = (ready ? pctOf(c.reg[l.c]) : 0) + '%';
      e.vw.textContent = showWas && c.disc[l.c] ? money(c.reg[l.c]) : '';
      e.pill.textContent = showWas && c.disc[l.c] ? c.disc[l.c] + '% off' : '';
      e.pill.hidden = !e.pill.textContent;
      e.delta.textContent = d === 0 ? 'Lowest' : '+' + money(d);
    });
    rowsEl.style.height = 'calc(var(--cgkp-rh) * ' + vis.length + ')';

    // key, notice
    $('[data-key-regular]').hidden = !showWas;
    var zb = $('[data-zoom]'); zb.classList.toggle('is-on', st.zoom); zb.setAttribute('aria-pressed', st.zoom ? 'true' : 'false'); zb.textContent = st.zoom ? 'Zoomed to differences' : 'Zoom to differences';
    $('[data-sort]').textContent = 'Sort: ' + (st.sort === 'price' ? 'Price' : 'Color');
    var notice = $('[data-notice]'), nt = '';
    if (c.codePct) nt = 'Comparison pricing applied (' + st.code + ', ' + c.codePct + '% off). This is not a discount code and can’t be used at checkout. Prices are estimates only.';
    else if (isW) nt = st.showRetail ? 'Showing retail prices for your client. Your wholesale pricing is ' + wPct + '% off these totals.' : 'Showing your wholesale pricing (' + wPct + '% off retail). Sale promotions don’t apply to wholesale orders.';
    notice.hidden = !nt; $('[data-notice-text]').textContent = nt;
    notice.classList.toggle('is-amber', !!c.codePct); notice.classList.toggle('is-teal', !c.codePct);
    retailBtn.hidden = !isW; retailBtn.classList.toggle('is-on', st.showRetail); retailBtn.setAttribute('aria-pressed', st.showRetail ? 'true' : 'false');
    codeForm.hidden = !!c.codePct; codeChip.hidden = !c.codePct;
    $('[data-codechip-text]').textContent = c.codePct ? st.code + ' · ' + c.codePct + '% off' : '';
    $('[data-chart-sub]').textContent = Z.label + ' · ' + T.label + ' package · ' + c.list.reduce(function (a, b) { return a + b.qty; }, 0) + ' cabinets and parts. Tap a finish to see its full list.';

    // hero
    var sr = c.reg[sel.c], sp = c.disc[sel.c], sd = c.totals[sel.c];
    var spTier = P ? P.tiers.filter(function (tr) { return sr >= tr.min; }).pop() : null;
    var nxt = P ? P.tiers.filter(function (tr) { return sr < tr.min; })[0] : null;
    $('[data-hero-label]').textContent = Z.label + ' · ' + T.label + ' package' + (isW && !st.showRetail ? ' · your wholesale price' : '');
    $('[data-hero-name]').textContent = sel.n;
    var hd = $('[data-hero-img]');
    heroDoor.style.backgroundColor = sel.hex;
    if (sel.door) { hd.src = img(sel.door, 240); hd.alt = sel.n + ' sample door'; hd.hidden = false; } else { hd.hidden = true; }
    $('[data-hero-was]').textContent = showWas && sp ? money(sr) : '';
    var save = $('[data-hero-save]'), sv = '';
    if (c.sale && sp && spTier) sv = 'You save ' + money(sr - sd) + ' with ' + sp + '% off orders over ' + money(spTier.min);
    else if (c.codePct) sv = 'Comparison pricing with ' + st.code + ' (' + c.codePct + '% off)';
    save.textContent = sv; save.hidden = !sv;
    var nudge = $('[data-hero-nudge]'), nu = '';
    if (c.sale && nxt && nxt.min - sr <= Math.max(1500, nxt.min * 0.3)) nu = 'Add ' + money(nxt.min - sr) + ' more and your whole order gets ' + nxt.pct + '% off.';
    nudge.textContent = nu; nudge.hidden = !nu;
    $('[data-hero-range]').textContent = 'All ' + vis.length + ' finishes shown: ' + money(lo) + ' – ' + money(hi);

    // plan
    var R = PLAN[st.size], sl = lum(sel.hex);
    var pr = $('[data-plan]');
    pr.setAttribute('aria-label', 'Plan view of a ' + Z.label + ' kitchen in ' + sel.n);
    $('[data-dimx]').style.width = Z.w * S + 'px'; $('[data-dimx]').textContent = Z.dx;
    $('[data-dimy]').style.height = Z.h * S + 'px'; $('[data-dimy] span').textContent = Z.dy;
    roomEl.style.width = Z.w * S + 'px'; roomEl.style.height = Z.h * S + 'px';
    roomEl.classList.toggle('is-u', !!Z.u);
    $('[data-legend-swatch]').style.backgroundColor = sel.hex;
    $('[data-legend-name]').textContent = (st.planView === 'wall' ? 'Wall cabinets in ' : 'Base cabinets in ') + sel.n.replace(' Shaker', '');
    roomEl.classList.toggle('is-wallview', st.planView === 'wall');
    setPressed(planToggle, st.planView);
    IDS.forEach(function (id) {
      var r = R[id] || PLAN.island[id] || PLAN.u[id], on = !!R[id], kind = KIND[id], el = pieceEls[id];
      var up = false, label = '', sku = baseSkuFor(id, T);
      if (kind === 'corner' || kind === 'drw') up = st.tier !== 'essentials';
      if (kind === 'swap') up = T.pantry;
      if (sku && id !== 'cB' && id !== 'cD' && kind !== 'fill') label = shortSku(sku);
      if (id === 'dw') label = 'DW'; if (id === 'range') label = 'Range'; if (id === 'fridge') label = 'Fridge';
      var cab = isCab(kind);
      el.className = 'cgkp-pc ' + kind + (up ? ' is-up ' + (tierFlip % 2 ? 'pa' : 'pb') : '') + (on ? '' : ' is-gone') + (r[3] > r[2] * 1.4 && r[2] * S < 40 ? ' is-vert' : '') + (hlNow && sku === hlNow ? ' is-hl' : '');
      el.style.left = r[0] * S + 'px'; el.style.top = r[1] * S + 'px'; el.style.width = r[2] * S + 'px'; el.style.height = r[3] * S + 'px';
      el.style.backgroundColor = cab ? sel.hex : (kind === 'appl' ? '' : (kind === 'fill' ? 'rgba(31,38,35,.55)' : 'transparent'));
      if (sku) {
        el.setAttribute('data-sku', sku);
        if (el.tagName === 'BUTTON') { el.setAttribute('aria-label', sku + ', ' + itemName(sku)); el.title = sku + ' · ' + itemName(sku); el.tabIndex = on && st.planView === 'base' ? 0 : -1; }
      }
      el.firstChild.textContent = label;
    });
    var F = T.overFridge === 'W361524B' ? 24 : 12, WR = WPLAN[st.size];
    WIDS.forEach(function (id) {
      var el = wallEls[id], kind = WKIND[id], r = (WR[id] || WPLAN.u[id] || WPLAN.island[id]).slice();
      if (id === 'wlF') r[2] = F;
      if (id === 'wrF') { r[0] = Z.w - F; r[2] = F; }
      var on = !!WR[id] && !(kind === 'swap' && T.pantry), sku = wallSkuFor(id, T);
      el.className = 'cgkp-wc ' + (kind === 'fill' ? 'fill' : 'cab') + (on ? '' : ' is-gone') + (r[3] > r[2] * 1.4 ? ' is-vert' : '') + (hlNow && sku === hlNow ? ' is-hl' : '');
      el.style.left = r[0] * S + 'px'; el.style.top = r[1] * S + 'px'; el.style.width = r[2] * S + 'px'; el.style.height = r[3] * S + 'px';
      el.style.backgroundColor = kind === 'fill' ? 'rgba(31,38,35,.55)' : sel.hex;
      el.setAttribute('data-sku', sku); el.setAttribute('aria-label', sku + ', ' + itemName(sku)); el.title = sku + ' · ' + itemName(sku);
      el.tabIndex = on && st.planView === 'wall' ? 0 : -1;
      el.firstChild.textContent = kind === 'fill' ? '' : shortSku(sku);
    });

    // drivers
    function tot(sz, tr) { return total(sel, buildList(sz, tr)); }
    var ess = tot(st.size, 'essentials'), des = tot(st.size, 'designer'), small = tot('10x10', st.tier), big = tot('island', st.tier);
    var fPct = (rHi - rLo) / rLo, pPct = (des - ess) / ess, sPct = (big - small) / small, mx = Math.max(fPct, pPct, sPct);
    function pf(x) { return '+' + Math.round(x * 100) + '%'; }
    var drv = [
      ['Finish', 'Lowest to highest finish', fPct, '#2d6a8f'],
      ['Package', 'Essentials to Designer', pPct, '#3a423e'],
      ['Kitchen size', '10×10 to 12×14 + island', sPct, '#3a423e']
    ];
    var dBox = $('[data-drivers]');
    if (!dBox.children.length) dBox.innerHTML = drv.map(function () { return '<div class="cgkp-drv"><b><span></span><small></small></b><span class="cgkp-lane"><span class="cgkp-bar"></span></span><span class="cgkp-pct"></span></div>'; }).join('');
    drv.forEach(function (d, i) {
      var el = dBox.children[i];
      el.querySelector('b span').textContent = d[0]; el.querySelector('small').textContent = d[1];
      var bar = el.querySelector('.cgkp-bar'); bar.style.width = (ready ? d[2] / mx * 100 : 0) + '%'; bar.style.backgroundColor = d[3];
      el.querySelector('.cgkp-pct').textContent = pf(d[2]);
    });
    $('[data-drv-sub]').textContent = 'For ' + sel.n + '. Each bar is the biggest price jump that choice can make.';
    $('[data-callout]').textContent = 'Your finish changes the price by ' + pf(fPct) + ' at most. Kitchen size and package matter far more, so pick the finish you love.';

    // items
    $('[data-items-sub]').textContent = sel.n + ' · ' + Z.label + ' · ' + T.label;
    $('[data-items]').innerHTML = GROUPS.map(function (g) {
      var its = c.list.filter(function (it) { return it.group === g[0]; });
      if (!its.length) return '';
      return '<div class="cgkp-ig">' + esc(g[1]) + '</div>' + its.map(function (it) {
        var isNew = st.tier !== 'essentials' && !c.baseSkus[it.sku];
        return '<div class="cgkp-it" data-sku="' + esc(it.sku) + '" data-group="' + it.group + '"><span class="cgkp-q">' + it.qty + '×</span><span>' + esc(itemName(it.sku)) + '<span class="cgkp-s">' + esc(it.sku) + '</span></span><span>' + (isNew ? '<span class="cgkp-new">Upgrade</span>' : '') + '</span><span class="cgkp-p">' + money(unitPrice(sel, it.sku) * it.qty) + '</span></div>';
      }).join('');
    }).join('');
    Array.prototype.forEach.call($('[data-items]').querySelectorAll('.cgkp-it'), function (row) {
      var sk = row.getAttribute('data-sku'), grp = row.getAttribute('data-group');
      row.classList.toggle('is-hl', !!hlNow && sk === hlNow);
      row.addEventListener('mouseenter', function () { hl(sk); });
      row.addEventListener('mouseleave', function () { hl(pinSku); });
      row.addEventListener('click', function () {
        pinSku = pinSku === sk ? '' : sk;
        var want = grp === 'wall' ? 'wall' : (grp === 'base' || grp === 'tall' ? 'base' : st.planView);
        if (pinSku && want !== st.planView) { st.planView = want; update(false); }
        hl(pinSku);
      });
    });
    var sums = '';
    if (sp) {
      var dl = c.sale ? 'Sale: ' + sp + '% off' : (c.codePct ? 'Comparison code ' + st.code + ': ' + sp + '% off' : 'Wholesale: ' + sp + '% off');
      sums += '<div class="cgkp-sub2"><span>' + (isW && !c.codePct ? 'Retail price' : 'Regular price') + '</span><span>' + money(sr) + '</span></div><div class="cgkp-sub2 is-pl"><span>' + esc(dl) + '</span><span>−' + money(sr - sd) + '</span></div>';
    }
    var sl2 = sp ? (c.sale ? 'Sale price total' : (c.codePct ? 'Estimated comparison total' : 'Your wholesale total')) : 'Cabinets & parts total';
    sums += '<div class="cgkp-sum"><span>' + sl2 + '</span><b>' + money(sd) + '</b></div><div class="cgkp-sumest"><span class="cgkp-est">Estimate only, not a quote</span></div>';
    $('[data-sums]').innerHTML = sums;
    var shop = $('[data-shop-link]'); shop.href = sel.url; shop.textContent = 'Shop ' + sel.n;

    // promo banner + fine print
    var banner = $('[data-promo-banner]');
    if (banner) { var on2 = !!P; banner.hidden = !on2; if (on2) banner.textContent = 'Sale: ' + P.tiers.map(function (tr) { return tr.pct + '% off orders over ' + money(tr.min); }).join(' · ') + (P.endsAt ? ' · Ends ' + P.endsAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : ''); }
    var terms = $('[data-promo-terms]');
    if (terms) terms.textContent = P ? 'Sale prices show the current promotion (' + P.tiers.map(function (tr) { return tr.pct + '% off orders over ' + money(tr.min); }).join(', ') + ') applied to the whole cabinet order.' : '';

    renderInfo();
    paintNumbers(c);
  }

  // ---------- go ----------
  update(true);
  requestAnimationFrame(function () { setTimeout(function () { ready = true; update(false); }, 80); });
  function goSale() { if (promo()) { st.prices = 'sale'; update(true); } }
  setTimeout(goSale, reduce ? 0 : 1700);
  document.addEventListener('cg:promo-ready', function () { if (st.prices === 'sale') update(true); });
})();
